<script lang="ts">
	import MetadataList from '$lib/MetadataList.svelte';
	import { getModalContext } from 'src/contexts/modal.context.svelte';
	import type { ChatMessage } from 'src/types/llm';

	interface Props {
		message: ChatMessage;
	}
	let { message }: Props = $props();

	const modalCtx = getModalContext();

	const basicInfo = $derived({
		id: message.id,
		role: message.role,
		...(message.status && { status: message.status })
	});

	const overallTimings = $derived.by(() => {
		const { steps, ...overallTimings } = message.timings;
		return overallTimings;
	});
</script>

<div class="dialog">
	<h1>Message Info</h1>

	<div class="basic-info">
		<MetadataList metadata={basicInfo} />
	</div>

	{#if message.classification}
		<div class="section">
			<h3>Classification</h3>
			<MetadataList metadata={message.classification} />
		</div>
	{/if}

	{#if message.topic}
		<div class="section">
			<h3>Topic</h3>
			<MetadataList metadata={message.topic} />
		</div>
	{/if}

	{#if message.available_tools && message.available_tools.length > 0}
		<div class="section">
			<h3>Tool Calls</h3>
			<MetadataList metadata={{ available_tools: message.available_tools }} />
		</div>
	{/if}

	{#if message.toolCalls && message.toolCalls.length > 0}
		<div class="section">
			{#each message.toolCalls as toolCall (toolCall.call_id)}
				<MetadataList metadata={toolCall} />
			{/each}
		</div>
	{/if}

	{#if message.timings}
		<div class="section">
			<h3>Timings</h3>
			<MetadataList metadata={overallTimings} />
			<MetadataList metadata={message.timings.steps} />
		</div>
	{/if}

	{#if message.content}
		<div class="section">
			<h3>Content</h3>
			<code class="scrollable-content">{message.content}</code>
		</div>
	{/if}

	{#if message.reasoning_content}
		<div class="section">
			<h3>Reasoning Content</h3>
			<code class="scrollable-content">{message.reasoning_content}</code>
		</div>
	{/if}

	<button class="glass" onclick={() => modalCtx.closeModal()}>Close</button>
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.dialog {
		@include lib.flex-column();
		gap: 1rem;
		font-size: 0.875rem;
		max-height: 80vh;
		overflow-y: auto;

		// HACK todo fox
		margin: -0.5rem;
		padding: 0.5rem;

		h1 {
			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			font-weight: 600;
		}

		h3 {
			font-size: 1rem;
			margin: 0 0 0.5rem 0;
			font-weight: 600;
		}

		.section {
			@include lib.flex-column();
			gap: 0.5rem;
			padding-top: 1rem;
		}

		.scrollable-content {
			max-height: 300px;
			overflow-y: auto;
			overflow-x: auto;
			padding: 1rem;
			border: 1px solid var(--border-subtle);
			border-radius: 0.5rem;
			background: var(--state-hover);
			font-size: 0.875rem;
			line-height: 1.5;
			white-space: pre-wrap;
			word-break: break-word;
		}

		button {
			margin-top: 1rem;
		}
	}
</style>
